export default __webpack_public_path__ + "static/3-home-page-a9755e93f5c19f7b5172ed35d966ede9.jpg";